// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.complete-admin-profile_container__jF3i5 {
  display: grid;
  background-color: var(--primary-background-color);
  padding: 48px;
  gap: 24px;
}

.complete-admin-profile_wrapper__EzcR\\+ {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 32px;
}

.complete-admin-profile_header__w4ohI {
  display: flex;
  align-items: center;
  gap: 12px;
}

.complete-admin-profile_content__NNoUn {
  display: grid;
  grid-template-rows: min-content 1fr auto;
  gap: 32px;
  align-items: center;
}

.complete-admin-profile_grey-input__kVp-x {
  border: none !important;
  background-color: var(--primary-background-color);
}

.complete-admin-profile_form__JJZsE {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 24px;
  justify-content: center;
}

.complete-admin-profile_company-informations__tII1n {
  background-color: var(--white-text-color);
  padding: 24px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;

  & .complete-admin-profile_input__knO3L {
    border: 0;
    font-size: 24px;
    font-weight: 700;
    padding-left: 0;

    &:active,
    &:focus {
      outline: none;
    }
  }
}

.complete-admin-profile_personal-informations__FNHiA {
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: var(--white-text-color);
  padding: 24px;
}

.complete-admin-profile_personal-header__vFHKW {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--primary-border-color);
}

.complete-admin-profile_personal-fields__E1dlk {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.complete-admin-profile_company-fields__F5Vn7 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.complete-admin-profile_actions__finXY {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--primary-border-color);
  padding: 24px 0;
  background-color: var(--primary-background-color);
}

.complete-admin-profile_completion__cbIUM {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 24px;
  min-width: 407px;
}

.complete-admin-profile_tasks__i4UxL {
  background-color: var(--white-text-color);
  padding: 24px;
  border-radius: 4px;
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 24px;
}

.complete-admin-profile_tasks-item__0Tlwz {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

@media (max-width: 1368px) {
  .complete-admin-profile_wrapper__EzcR\\+ {
    grid-template-columns: 1fr min-content;
  }
}

@media (max-width: 980px) {
  .complete-admin-profile_container__jF3i5 {
    padding: 24px;
  }

  .complete-admin-profile_wrapper__EzcR\\+ {
    grid-template-columns: 1fr;
  }

  .complete-admin-profile_company-fields__F5Vn7 {
    grid-template-columns: 1fr;
    margin-bottom: 12px;
    gap: 12px;
  }

  .complete-admin-profile_personal-fields__E1dlk {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/complete-admin-profile.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iDAAiD;EACjD,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;;EAEtB;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,eAAe;;IAEf;;MAEE,aAAa;IACf;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iDAAiD;EACjD,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":[".container {\n  display: grid;\n  background-color: var(--primary-background-color);\n  padding: 48px;\n  gap: 24px;\n}\n\n.wrapper {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 32px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.content {\n  display: grid;\n  grid-template-rows: min-content 1fr auto;\n  gap: 32px;\n  align-items: center;\n}\n\n.grey-input {\n  border: none !important;\n  background-color: var(--primary-background-color);\n}\n\n.form {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 24px;\n  justify-content: center;\n}\n\n.company-informations {\n  background-color: var(--white-text-color);\n  padding: 24px;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n\n  & .input {\n    border: 0;\n    font-size: 24px;\n    font-weight: 700;\n    padding-left: 0;\n\n    &:active,\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n.personal-informations {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  background-color: var(--white-text-color);\n  padding: 24px;\n}\n\n.personal-header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid var(--primary-border-color);\n}\n\n.personal-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.company-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  border-top: 1px solid var(--primary-border-color);\n  padding: 24px 0;\n  background-color: var(--primary-background-color);\n}\n\n.completion {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 24px;\n  min-width: 407px;\n}\n\n.tasks {\n  background-color: var(--white-text-color);\n  padding: 24px;\n  border-radius: 4px;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  gap: 24px;\n}\n\n.tasks-item {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n@media (max-width: 1368px) {\n  .wrapper {\n    grid-template-columns: 1fr min-content;\n  }\n}\n\n@media (max-width: 980px) {\n  .container {\n    padding: 24px;\n  }\n\n  .wrapper {\n    grid-template-columns: 1fr;\n  }\n\n  .company-fields {\n    grid-template-columns: 1fr;\n    margin-bottom: 12px;\n    gap: 12px;\n  }\n\n  .personal-fields {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `complete-admin-profile_container__jF3i5`,
	"wrapper": `complete-admin-profile_wrapper__EzcR+`,
	"header": `complete-admin-profile_header__w4ohI`,
	"content": `complete-admin-profile_content__NNoUn`,
	"grey-input": `complete-admin-profile_grey-input__kVp-x`,
	"form": `complete-admin-profile_form__JJZsE`,
	"company-informations": `complete-admin-profile_company-informations__tII1n`,
	"input": `complete-admin-profile_input__knO3L`,
	"personal-informations": `complete-admin-profile_personal-informations__FNHiA`,
	"personal-header": `complete-admin-profile_personal-header__vFHKW`,
	"personal-fields": `complete-admin-profile_personal-fields__E1dlk`,
	"company-fields": `complete-admin-profile_company-fields__F5Vn7`,
	"actions": `complete-admin-profile_actions__finXY`,
	"completion": `complete-admin-profile_completion__cbIUM`,
	"tasks": `complete-admin-profile_tasks__i4UxL`,
	"tasks-item": `complete-admin-profile_tasks-item__0Tlwz`
};
export default ___CSS_LOADER_EXPORT___;
